import React from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import cx from "classnames";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid, GridRow, GridColumn } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { convertPriceToSelectedCurrency } from "../../helpers/currencyHelpers";
import { resetStore } from "../../actions/resetStoreActions";
import {
  getPlaceHolders,
  clearAnalyticsPlaceHolders,
  getAnalyticsPlaceHolders
} from "../../actions/placeHoldersActions";
import * as filterActions from "../../actions/filterActions";
import { isRTL } from "../../reducers";
import styles from "./styles.less";
import { getPriceWithoutTax } from "../../helpers/priceCalculationHelper";
import { getPropertyItemTitle } from "../../helpers/general-helpers";

class Filter extends React.Component {
  state = {
    placeHoldersReceivedFromServer: false,
    origPriceRange: {
      min: 0,
      max: 1
    },
    chosenPriceRange: {
      min: 0,
      max: 1
    },
    pageType: {
      data: null,
      isDeals: false,
      isDealsSearch: false,
      isRegionalSearch: false,
      isRooms: false
    },
    haveFilters: false,
    chosenPriceCurrency: null,
    priceWereUpdated: false
  };

  componentDidMount() {
    this.setFilters();
  }

  componentDidUpdate(prevProps) {
    const {
      rooms,
      dealSearchResults,
      deals,
      regionResults,
      selectedCurrencyCode,
      currencies
    } = this.props;
    if (
      prevProps.rooms != rooms ||
      prevProps.dealSearchResults != dealSearchResults ||
      prevProps.deals != deals ||
      prevProps.regionResults != regionResults ||
      prevProps.selectedCurrencyCode != selectedCurrencyCode ||
      prevProps.currencies != currencies
    ) {
      this.setFilters();
    }
  }

  setFilters = () => {
    const pageType = this.calcPageType();
    const currencyData = this.getDataCurrency(pageType);
    const priceRange = this.calcPriceRangeRoomResults(pageType, currencyData);
    this.setState({
      chosenPriceRange: { min: priceRange.min, max: priceRange.max },
      origPriceRange: { min: priceRange.min, max: priceRange.max },
      chosenPriceCurrency: priceRange && priceRange.currency,
      priceWereUpdated: true,
      pageType,
      currencyData
    });
  };

  calcPageType = () => {
    const {
      rooms,
      dealSearchResults,
      deals,
      regionResults,
      routing,
      selectedHotelId
    } = this.props;
    let data = null;
    let isDeals = false;
    let isDealsSearch = false;
    let isRegionalSearch = false;
    let isRooms = false;
    const pathname =
      routing &&
      routing.location &&
      routing.location.pathname &&
      routing.location.pathname;
    if (pathname && pathname.indexOf("/deals/deal") > -1) {
      data = dealSearchResults;
      isDealsSearch = true;
    } else if (pathname && pathname.indexOf("/deals") > -1) {
      data = deals;
      isDeals = true;
    } else if (selectedHotelId) {
      data = rooms;
      isRooms = true;
    } else {
      data = regionResults;
      isRegionalSearch = true;
    }
    const pageType = {
      data,
      isDeals,
      isDealsSearch,
      isRegionalSearch,
      isRooms
    };
    return pageType;
  };

  checkBoxForFilter = (
    data,
    paramId,
    paramName,
    onClickFunction,
    isSelected
  ) => {
    const { isRtl } = this.props;
    return (
      <label
        htmlFor={data[paramId]}
        className={styles.container}
        key={data[paramId]}
      >
        <input
          type="checkbox"
          id={data[paramId]}
          onClick={() => onClickFunction(data, paramName)}
          checked={isSelected ? "checked" : ""}
        />
        <span
          className={cx(styles.checkmark, {
            [styles.rtl]: !isRtl
          })}
        />
        {data[paramName]}
      </label>
    );
  };

  filterByRoomType = room => {
    const { actions, roomFilter } = this.props;
    let roomIndex =
      roomFilter &&
      roomFilter.findIndex(r => r.id == room.id && r.name == room.name);
    const updatedRoomFilter = [...roomFilter];
    if (roomIndex > -1) {
      updatedRoomFilter.splice(roomIndex, 1);
    } else {
      updatedRoomFilter.push(room);
    }
    actions.setRoomFilters(updatedRoomFilter);
  };

  filterByRegion = region => {
    const { actions, regionFilter } = this.props;
    let regionIndex =
      regionFilter &&
      regionFilter.findIndex(
        r => r.regionId == region.regionId && r.title == region.title
      );
    const updatedRegionFilter = [...regionFilter];
    if (regionIndex > -1) {
      updatedRegionFilter.splice(regionIndex, 1);
    } else {
      updatedRegionFilter.push(region);
    }
    actions.setRegionFilters(updatedRegionFilter);
  };

  filterByPlan = plan => {
    const { actions, planFilter } = this.props;
    let planIndex =
      planFilter &&
      planFilter.findIndex(
        p => p.planCode == plan.planCode && p.planName == plan.planName
      );
    const updatedRoomFilter = [...planFilter];
    if (planIndex > -1) {
      updatedRoomFilter.splice(planIndex, 1);
    } else {
      updatedRoomFilter.push(plan);
    }
    actions.setPlanFilters(updatedRoomFilter);
  };

  filterByHotel = hotel => {
    const { actions, hotelFilter } = this.props;
    let hotelIndex =
      hotelFilter &&
      hotelFilter.findIndex(
        p => p.hotelID == hotel.hotelID && p.hotelName == hotel.hotelName
      );
    const updatedHotelFilter = [...hotelFilter];
    if (hotelIndex > -1) {
      updatedHotelFilter.splice(hotelIndex, 1);
    } else {
      updatedHotelFilter.push(hotel);
    }
    actions.setHotelFilters(updatedHotelFilter);
  };

  calcPriceRangeRoomResults = (pageType, currencyData) => {
    const { selectedPaxId, currencies, selectedCurrencyCode } = this.props;
    let propName = "";
    if (pageType.isDealsSearch || pageType.isDeals) {
      propName = "totalPrice";
    } else if (pageType.isRooms) {
      propName = "lowestPrice";
    } else {
      propName = "startFromPrice";
    }
    const hasResults =
      pageType.isDeals || pageType.isRegionalSearch
        ? pageType.data
        : pageType.data && pageType.data[selectedPaxId];
    const data =
      pageType.isDeals || pageType.isRegionalSearch
        ? pageType.data
        : pageType.data[selectedPaxId];
    let maxPrice = null;
    let minPrice = null;
    if (pageType.isRegionalSearch) {
      const hasPrices = hasResults && data;
      const firstPrice =
        hasPrices && data[0] && data[0].roomResult && data[0].roomResult[0];
      maxPrice = firstPrice ? firstPrice[propName] : 0;
      minPrice = firstPrice ? firstPrice[propName] : 0;
      hasPrices &&
        data.forEach(element => {
          element &&
            element.roomResult.forEach(subElement => {
              if (subElement[propName] < minPrice) {
                minPrice = subElement[propName];
              }
              if (subElement[propName] > maxPrice) {
                maxPrice = subElement[propName];
              }
            });
        });
    } else {
      const isSinglePrice = hasResults && data[propName];
      maxPrice = hasResults
        ? isSinglePrice
          ? data[propName]
          : data[0][propName]
        : 0;
      minPrice = hasResults
        ? isSinglePrice
          ? data[propName]
          : data[0][propName]
        : 0;
      if (!isSinglePrice) {
        hasResults &&
          data.forEach(element => {
            if (element[propName] < minPrice) {
              minPrice = element[propName];
            }
            if (pageType.isDeals || pageType.isDealsSearch) {
              if (element[propName] > maxPrice) {
                maxPrice = element[propName];
              }
            } else {
              element &&
                element.rates &&
                element.rates.forEach(rate => {
                  if (rate.totalPrice > maxPrice) {
                    maxPrice = rate.totalPrice;
                  }
                });
            }
          });
      }
    }

    let minOrig = this.splitPriceToNumberAndCurrency(
      convertPriceToSelectedCurrency(
        minPrice,
        selectedCurrencyCode,
        currencyData && currencyData.currencyCode,
        currencyData && currencyData.currency,
        currencies
      )
    );
    let maxOrig = this.splitPriceToNumberAndCurrency(
      convertPriceToSelectedCurrency(
        maxPrice,
        selectedCurrencyCode,
        currencyData && currencyData.currencyCode,
        currencyData && currencyData.currency,
        currencies
      )
    );
    return {
      max: Math.round(maxOrig && maxOrig.priceNumber),
      min: Math.round(minOrig && minOrig.priceNumber),
      currency: maxOrig && maxOrig.currency
    };
  };

  getDataCurrency = pageType => {
    const haveData = pageType.data && pageType.data[0];
    let currencyCode = "";
    let currency = "";
    if (pageType.isRegionalSearch) {
      currencyCode =
        haveData &&
        pageType.data[0].roomResult &&
        pageType.data[0].roomResult[0] &&
        pageType.data[0].roomResult[0].currencyCode;
      currency =
        haveData &&
        pageType.data[0].roomResult &&
        pageType.data[0].roomResult[0] &&
        pageType.data[0].roomResult[0].currency;
    } else if (pageType.isDeals) {
      currencyCode =
        haveData && pageType.data[0] && pageType.data[0].currencyCode;
      currency = haveData && pageType.data[0] && pageType.data[0].currency;
    } else {
      currencyCode =
        haveData && pageType.data[0][0] && pageType.data[0][0].currencyCode;
      currency =
        haveData && pageType.data[0][0] && pageType.data[0][0].currency;
    }
    return {
      currency,
      currencyCode
    };
  };

  splitPriceToNumberAndCurrency = price => {
    let isFirstNumber = false;
    let currency = "";
    let number = "";
    let isNumber = false;
    const priceArray = price && price.split("");
    priceArray &&
      priceArray.forEach(p => {
        isNumber = !isNaN(p * 1);
        if (!isNumber && !isFirstNumber) {
          currency = currency + p;
        } else if (isNumber) {
          number = number + p;
          isFirstNumber = true;
        }
      });
    return {
      currency,
      priceNumber: number * 1
    };
  };

  priceRangeFilter = (/*selectedCurrencyCode*/) => {
    const {
      chosenPriceRange,
      origPriceRange,
      chosenPriceCurrency
    } = this.state;
    const { displayPriceWithoutTaxes, taxesPrecentage } = this.props;
    let calculatedMaxPrice = origPriceRange && origPriceRange.max;
    let calculatedMinPrice = origPriceRange && origPriceRange.min;

    if (displayPriceWithoutTaxes) {
      calculatedMaxPrice = getPriceWithoutTax(
        calculatedMaxPrice,
        taxesPrecentage
      );
      calculatedMinPrice = getPriceWithoutTax(
        calculatedMinPrice,
        taxesPrecentage
      );
    } else {
      // do nothing
    }

    return (
      <InputRange
        maxValue={calculatedMaxPrice}
        minValue={calculatedMinPrice}
        formatLabel={value =>
          this.addCurrencyToPrice(value, chosenPriceCurrency)
        }
        value={chosenPriceRange}
        onChange={value => this.setState({ chosenPriceRange: value })}
        onChangeComplete={value => this.setPriceRanges(value)}
      />
    );
  };

  addCurrencyToPrice = (value, chosenPriceCurrency) =>
    `${chosenPriceCurrency}${value}`;

  setPriceRanges = value => {
    const { actions, selectedCurrencyCode, currencies } = this.props;
    const { currencyData } = this.state;
    const priceMin = this.splitPriceToNumberAndCurrency(
      convertPriceToSelectedCurrency(
        value.min,
        currencyData.currencyCode,
        selectedCurrencyCode,
        currencyData.currency,
        currencies
      )
    );
    const priceMax = this.splitPriceToNumberAndCurrency(
      convertPriceToSelectedCurrency(
        value.max,
        currencyData.currencyCode,
        selectedCurrencyCode,
        currencyData.currency,
        currencies
      )
    );
    actions.setMaxPriceRangeFilters(priceMax && priceMax.priceNumber);
    actions.setMinPriceRangeFilters(priceMin && priceMin.priceNumber);
  };

  getPlansList = (data, haveData, isDeals) => {
    const { selectedPaxId, roomFilter } = this.props;
    const plansList = [];
    if (haveData) {
      const selectedRooms = data[selectedPaxId].filter(
        r => roomFilter.length === 0 || roomFilter.includes(r)
      );
      selectedRooms.forEach(element => {
        if (isDeals) {
          this.checkIfPlanInListAndEditListEccoringley(
            plansList,
            element,
            "hotelName"
          );
        } else {
          element &&
            element.rates &&
            element.rates.forEach(rate => {
              this.checkIfPlanInListAndEditListEccoringley(
                plansList,
                rate,
                "name"
              );
            });
        }
      });
    }
    return plansList;
  };

  getHotelsList = (dataForList, haveData, isDeals) => {
    const { selectedPaxId } = this.props;
    const hotelsList = [];
    const paramName = isDeals ? "hotelName" : "name";
    const paramId = isDeals ? "hotelId" : "hotelID";
    const data = isDeals
      ? dataForList[selectedPaxId]
      : dataForList[selectedPaxId] && dataForList;
    if (haveData) {
      if (isDeals) {
        if (data && data[paramName] != null) {
          this.checkIfHotelInListAndEditListEccoringley(
            hotelsList,
            data[selectedPaxId],
            paramId,
            paramName
          );
        } else {
          data &&
            data.forEach(element => {
              this.checkIfHotelInListAndEditListEccoringley(
                hotelsList,
                element,
                paramId,
                paramName
              );
            });
        }
      } else {
        if (data && data.roomResult && data.roomResult[paramName] != null) {
          this.checkIfHotelInListAndEditListEccoringley(
            hotelsList,
            data[selectedPaxId],
            paramId,
            paramName
          );
        } else {
          data &&
            data.forEach(element => {
              element &&
                element.roomResult &&
                element.roomResult.forEach(hotel => {
                  let indexHotelInList =
                    hotelsList &&
                    hotelsList.findIndex(
                      p =>
                        p.hotelID == hotel[paramId] &&
                        p.hotelName == hotel[paramName]
                    );
                  if (indexHotelInList == -1) {
                    hotelsList.push({
                      hotelID: hotel[paramId],
                      hotelName: hotel[paramName]
                    });
                  }
                });
            });
        }
      }
    }
    return hotelsList;
  };

  checkIfPlanInListAndEditListEccoringley = (plansList, rate) => {
    let indexPlanInList =
      plansList &&
      plansList.findIndex(
        p => p.planName == rate.planName && p.planCode == rate.planCode
      );
    if (indexPlanInList == -1) {
      plansList.push({
        planCode: rate.planCode,
        planName: rate.planName
      });
    }
  };

  checkIfHotelInListAndEditListEccoringley = (
    hotelList,
    hotel,
    hotelIdProperty,
    hotelNameProperty
  ) => {
    let indexHotelInList =
      hotelList &&
      hotel &&
      hotelList.findIndex(
        p =>
          p.hotelID == hotel[hotelIdProperty] &&
          p[hotelNameProperty] == hotel[hotelNameProperty]
      );
    if (indexHotelInList == -1 && hotel != null) {
      hotelList.push({
        hotelID: hotel[hotelIdProperty],
        hotelName: hotel[hotelNameProperty]
      });
    }
  };

  render() {
    const {
      titles,
      selectedPaxId,
      selectedCurrencyCode,
      roomFilter,
      planFilter,
      regionFilter,
      hotelFilter,
      routing,
      thumbanilDisplay,
      showPricePerNightThumb,
      displayPriceWithoutTaxes,
      propertyType
    } = this.props;
    const showPlanAndPriceHandlers =
      !thumbanilDisplay ||
      (thumbanilDisplay &&
        routing &&
        routing.location.pathname.indexOf("hotel/room") > -1);
    const { pageType, origPriceRange } = this.state;
    const haveData =
      pageType.data && selectedPaxId != null && pageType.data[selectedPaxId];
    const plansList =
      (pageType.isRooms || pageType.isDealsSearch) &&
      this.getPlansList(pageType.data, haveData, pageType.isDealsSearch);
    const hotelsList =
      (pageType.isDeals || pageType.isRegionalSearch) &&
      this.getHotelsList(pageType.data, haveData, pageType.isDeals);
    const haveFilters =
      (plansList && plansList.length > 1) ||
      (hotelsList && hotelsList.length > 1) ||
      (origPriceRange.min > 0 && origPriceRange.max > 0) ||
      (pageType && pageType.data && pageType.data.length > 1);
    return (
      haveFilters && (
        <Grid className={styles.filterWrapper}>
          <GridRow>
            <GridColumn
              className={cx(styles.filterHeader, styles.filterHeaderMain)}
            >
              {titles.FilterBy}
            </GridColumn>
          </GridRow>
          {plansList &&
            plansList.length > 1 &&
            haveData &&
            plansList &&
            showPlanAndPriceHandlers && (
              <GridRow>
                <GridColumn>
                  <div
                    className={cx(styles.filterHeader, styles.filterHeaderSub)}
                  >
                    {titles.FilterByPlan}
                  </div>
                  <div className={styles.filterCheckBoxWrapper}>
                    {plansList.map(plan =>
                      this.checkBoxForFilter(
                        plan,
                        "planCode",
                        "planName",
                        this.filterByPlan,
                        planFilter.find(p => p.planCode === plan.planCode) !=
                          undefined
                      )
                    )}
                  </div>
                </GridColumn>
              </GridRow>
            )}
          {hotelsList &&
            hotelsList.length > 1 &&
            haveData && (
              <GridRow>
                <GridColumn>
                  <div
                    className={cx(styles.filterHeader, styles.filterHeaderSub)}
                  >
                    {titles.FilterByHotel}
                  </div>
                  <div className={styles.filterCheckBoxWrapper}>
                    {hotelsList.map(hotel =>
                      this.checkBoxForFilter(
                        hotel,
                        "hotelID",
                        "hotelName",
                        this.filterByHotel,
                        hotelFilter.find(h => h.hotelID === hotel.hotelID) !=
                          undefined
                      )
                    )}
                  </div>
                </GridColumn>
              </GridRow>
            )}
          {pageType.isRooms &&
            haveData &&
            pageType.data[selectedPaxId] instanceof Array && (
              <GridRow>
                <GridColumn>
                  <div
                    className={cx(styles.filterHeader, styles.filterHeaderSub)}
                  >
                    {titles.FilterByRoomType}{" "}
                    {getPropertyItemTitle(titles, propertyType)}
                  </div>
                  <div className={styles.filterCheckBoxWrapper}>
                    {pageType.data[selectedPaxId].map(room =>
                      this.checkBoxForFilter(
                        room,
                        "id",
                        "name",
                        this.filterByRoomType,
                        roomFilter.includes(room)
                      )
                    )}
                  </div>
                </GridColumn>
              </GridRow>
            )}
          {pageType.isRegionalSearch &&
            haveData &&
            pageType.data &&
            pageType.data.length > 1 && (
              <GridRow>
                <GridColumn>
                  <div
                    className={cx(styles.filterHeader, styles.filterHeaderSub)}
                  >
                    {titles.FilterByRegion}
                  </div>
                  <div className={styles.filterCheckBoxWrapper}>
                    {pageType.data.map(region =>
                      this.checkBoxForFilter(
                        region,
                        "regionId",
                        "title",
                        this.filterByRegion,
                        regionFilter.includes(region)
                      )
                    )}
                  </div>
                </GridColumn>
              </GridRow>
            )}
          {!displayPriceWithoutTaxes &&
            !showPricePerNightThumb &&
            showPlanAndPriceHandlers &&
            origPriceRange.max &&
            origPriceRange.min &&
            origPriceRange.max != origPriceRange.min && (
              <GridRow>
                <GridColumn>
                  <div
                    className={cx(styles.filterHeader, styles.filterHeaderSub)}
                  >
                    {titles.FilterByPrice}
                  </div>
                  <div
                    className={cx(
                      styles.filterCheckBoxWrapper,
                      styles.priceWrapper
                    )}
                  >
                    {haveData &&
                      origPriceRange.min > 0 &&
                      origPriceRange.max > 0 &&
                      this.priceRangeFilter(selectedCurrencyCode)}
                  </div>
                </GridColumn>
              </GridRow>
            )}
        </Grid>
      )
    );
  }
}

Filter.propTypes = {
  titles: PropTypes.object,
  //isMobileView: PropTypes.bool,
  // lang: PropTypes.string,
  isRtl: PropTypes.bool,
  dealSearchResults: PropTypes.array,
  rooms: PropTypes.object,
  actions: PropTypes.object,
  selectedPaxId: PropTypes.number,
  roomFilter: PropTypes.array,
  planFilter: PropTypes.array,
  regionFilter: PropTypes.array,
  hotelFilter: PropTypes.array,
  routing: PropTypes.object,
  regionResults: PropTypes.array,
  deals: PropTypes.array,
  currencies: PropTypes.array,
  selectedCurrencyCode: PropTypes.string,
  selectedHotelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thumbanilDisplay: PropTypes.bool,
  showPricePerNightThumb: PropTypes.bool,
  displayPriceWithoutTaxes: PropTypes.bool,
  taxesPrecentage: PropTypes.string,
  propertyType: PropTypes.string
};

const mapStateToProps = store => {
  const state = {
    // lang: store.lang,
    //isMobileView: store.isMobileView,
    isRtl: isRTL(store),
    selectedCurrencyCode: store.selectedCurrency,
    dealSearchResults: store.dealSearchResults,
    titles: store.titles,
    selectedPaxId: store.selectedPaxId,
    rooms: store.rooms,
    roomFilter: store.roomFilter,
    planFilter: store.planFilter,
    regionFilter: store.regionFilter,
    hotelFilter: store.hotelFilter,
    actions: store.actions,
    routing: store.routing,
    regionResults: store.regionResults,
    deals: store.deals,
    selectedHotelId: store.selectedHotelId,
    currencies: store.currencies,
    thumbanilDisplay: store.thumbanilDisplay,
    showPricePerNightThumb: store.showPricePerNightThumb,
    displayPriceWithoutTaxes: store.displayPriceWithoutTaxes,
    taxesPrecentage: store.taxesPrecentage,
    propertyType: store.propertyType
  };
  return state;
};

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    resetStore,
    getPlaceHolders,
    clearAnalyticsPlaceHolders,
    getAnalyticsPlaceHolders,
    ...filterActions
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/containers/Filter/Filter.js